import { Component } from "@angular/core";
import { MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Component({
  selector: "app-footer-banner",
  standalone: true,
  imports: [ToastModule],
  providers: [MessageService],
  templateUrl: "./footer-banner.component.html",
  styleUrl: "./footer-banner.component.css",
})
export class FooterBannerComponent {
   pwaUrl: string = `${environment.pwaFrontendBaseUrl}/auth/signup`;

  private insizonFrontendBaseUrl = environment.insizonFrontendBaseUrl;
  currentYear: number = new Date().getFullYear();
  insizonUrl = environment.insizonFrontendBaseUrl;
  constructor(private messageService: MessageService){}
  

  get getBugRepoLink() {
    return `${this.insizonFrontendBaseUrl}/bug-logs;`
  }

  get getFeatureLink() {
    return `${this.insizonFrontendBaseUrl}/`;
  }

  get getContactUsLink() {
    return `${this.insizonFrontendBaseUrl}/contact`;
  }

  noLink() {
    this.messageService.add({
      severity: "warn",
      summary: "No Link Found",
      detail: "Social media link is not available.",
    });
  }
  redirectToDownload() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const iOSStoreUrl = "https://apps.apple.com/app/idYOUR_APP_ID";
  const androidStoreUrl = "https://play.google.com/store/apps/details?id=com.poptheballon.insizion";
  const desktopPwaUrl = this.pwaUrl;

  console.log("User Agent:", userAgent);

  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    console.log("Redirecting to App Store");
    window.location.href = iOSStoreUrl;

  } else if (/android/i.test(userAgent)) {
    console.log("Redirecting to Play Store");
    window.location.href = androidStoreUrl;

  } else {
    console.log("Redirecting to Desktop PWA");
    window.location.href = desktopPwaUrl;
  }
}
}
